import * as style from './style.module.css';

const InputTextArea = ({ isError = false, ...props }) => {
    return <textarea {...props} className={`${style.textArea} ${isError ? style.inputError : ''}`} />;
};

export default InputTextArea;
